const SUCCESS = "success";
const DEFAULT = "default";

const TAG_TYPES = {
  SUCCESS,
  DEFAULT,
};

export default TAG_TYPES;
